import type { StudioPeriod, StudioPeriodPair } from 'src/components/star-grid/reportStudio.types';
export type StudioPairing = 'same' | 'prior_year' | 'prior_period';
export const pairStudioPeriods = (ids: readonly string[], periods: readonly StudioPeriod[], mode: StudioPairing): readonly StudioPeriodPair[] =>
  ids.map((id) => ({
    base: id,
    compare: mode === 'same' ? id : periods.find((period) => period.id === id)?.[mode === 'prior_year' ? 'prior_year_id' : 'prior_period_id'] ?? ''
  }));
